const glossaryIndex = {
	A: [
		{
			title: 'Abandoned Cart',
			info: 'When a visitor adds items to their shopping cart but leaves the website without completing the purchase.',
		},
		{
			title: 'Abandoned Cart Recovery',
			info: 'Abandoned cart recovery involves identifying visitors who partially completed a purchase and persuading them to complete it. With the right store builder, you can automatically or manually email these visitors, offering incentives like promo codes to encourage them to finalise their transactions.',
		},
		{
			title: 'A/B Testing',
			info: 'A method of comparing two versions of a webpage or marketing element to determine which one performs better in terms of conversion or engagement.',
		},
		{
			title: 'Accessibility',
			info: 'Web accessibility is the practice of designing websites and online tools to be usable by people with disabilities.',
		},
		{
			title: 'Affiliate',
			info: 'An individual or entity that promotes and sells products or services on behalf of another company in exchange for a commission.',
		},
		{
			title: 'Affiliate Marketing',
			info: 'A performance-based marketing strategy where affiliates earn a commission for promoting a product or service and driving sales through their own marketing efforts.',
		},
		{
			title: 'AJAX cart',
			info: 'A Shopify cart style that enables shoppers to stay on the product page even after adding an item to their cart.',
		},
		{
			title: 'Analytics',
			info: 'The process of collecting, measuring, analysing, and interpreting data to gain insights and make informed decisions to improve business performance. Google Analytics is a powerful tool for this.',
		},
		{
			title: 'API (Application Programming Interface)',
			info: 'A set of rules and protocols that allow different software applications to communicate and interact with each other.',
		},
		{
			title: 'App Store',
			info: 'A marketplace where users can find and download applications (apps) to enhance the functionality and features of their eCommerce platform.',
		},
		{
			title: 'AR (Augmented Reality)',
			info: "An interactive technology that overlays digital information, such as images, videos, or 3D models, onto the real-world environment, enhancing the user's perception and interaction.",
		},
		{
			title: 'Attribution',
			info: 'The process of assigning credit to different marketing channels or touchpoints that contribute to a conversion or sale.',
		},
		{
			title: 'Autoresponder',
			info: 'Autoresponders are automated e-newsletters sent to subscribers on your email list based on rules and time intervals you set using email marketing apps like [LINK].',
			link: {
				name: 'Klaviyo',
				url: 'https://www.klaviyo.com/',
			},
		},
	],
	B: [
		{
			title: 'B2B (Business-to-Business)',
			info: 'The exchange of products, services, or information between businesses rather than between businesses and consumers.',
		},
		{
			title: 'B2C (Business-to-Consumer)',
			info: 'The exchange of products, services, or information between businesses and consumers.',
		},
		{
			title: 'Back-End',
			info: 'The behind-the-scenes technology and infrastructure that powers an eCommerce website, including databases, servers, and administrative systems.',
		},
		{
			title: 'Blogging',
			info: 'The practice of regularly creating and publishing [LINK], typically on a website, to provide valuable content, engage with an audience, and drive traffic.',
			link: {
				name: 'articles',
				url: '/blog/',
			},
		},
		{
			title: 'Bounce Rate',
			info: 'The bounce rate is the percentage of visitors who leave a website without taking any further action.',
		},
		{
			title: 'Branding',
			info: 'The process of creating a unique identity, image, and reputation for a business or product to differentiate it from competitors and resonate with customers. There are entities like [LINK] that are entirely focused on branding.',
			link: {
				name: 'TapCreative',
				url: 'https://tapcreative.ie/',
			},
		},
		{
			title: 'Brick-and-mortar store',
			info: 'A brick-and-mortar store is a physical retail outlet where customers can purchase products in person.',
		},
		{
			title: 'Bundling',
			info: 'Bundling is a sales strategy where multiple products are combined and sold at a discounted price, often including complementary or similar items, to increase the average order value. You can find several apps in Shopify App Store that can help (e.g., [LINK]).',
			link: {
				name: 'Bundler',
				url: 'https://youtu.be/Hgn_JKbdq20',
			},
		},
	],
	C: [
		{
			title: 'Call to Action (CTA)',
			info: 'A prompt or instruction that encourages users to take a specific action, such as making a purchase, signing up for a newsletter, or contacting customer support.',
		},
		{
			title: 'Carousel',
			info: 'A slideshow-like element that displays multiple images or products in a rotating format, often used to highlight featured items or promotions.',
		},
		{
			title: 'Cart Abandonment Rate',
			info: 'The cart abandonment rate is the percentage of shoppers who add items to their cart but leave without completing the purchase.',
		},
		{
			title: 'Chargeback',
			info: "A chargeback is when a completed credit card transaction is reversed due to a customer dispute, resulting in a refund from the merchant's bank.",
		},
		{
			title: 'Checkout',
			info: 'The process by which customers review their selected products, provide shipping and payment information, and complete a purchase.',
		},
		{
			title: 'Clickthrough Rate (CTR)',
			info: 'Clickthrough rate (CTR) is the percentage of link clicks compared to link impressions.',
		},
		{
			title: 'CMS (Content Management System)',
			info: 'A software application or platform that allows users to create, manage, and modify digital content, such as web pages, blog posts, and product listings (e.g., Shopify, Magento, WordPress, PrestaShop).',
		},
		{
			title: 'Collaborator Account',
			info: "Collaborator Accounts allow you to request access to a client's Shopify store directly from your Partner Dashboard. These accounts provide a simpler and safer way for you to gain access to, and work on, your clients’ existing Shopify stores (Source: Shopify).",
		},
		{
			title: 'Cookie',
			info: "A cookie is a small file stored on a user's device that records their interaction with a website, including tracking their behaviour.",
		},
		{
			title: 'Comma Separated Values (CSV)',
			info: 'CSV is a file format for storing data in a spreadsheet, commonly used for product feed transfers.',
		},
		{
			title: 'Conversion',
			info: 'A conversion occurs when a website visitor completes a desired action, such as signing up for a mailing list or making a purchase.',
		},
		{
			title: 'Conversion Rate',
			info: 'The percentage of website visitors who complete a desired action, such as making a purchase or filling out a form, out of the total number of visitors.',
		},
		{
			title: 'Conversion Rate Optimization (CRO)',
			info: 'Conversion rate optimization (CRO) aims to improve website performance and increase the chances of visitors making a purchase. It utilises techniques like A/B testing, heatmaps ([LINK]), abandoned cart recovery, and customer surveys.',
			link: {
				name: 'Lucky Orange',
				url: 'https://www.luckyorange.com/',
			},
		},
		{
			title: 'CRM (Customer Relationship Management)',
			info: 'A system or strategy for managing interactions and relationships with customers, including storing customer data, tracking interactions, and providing personalised experiences.',
		},
		{
			title: 'Cross-Selling',
			info: "A sales technique where additional products or services related to the customer's current purchase are offered to encourage higher-value transactions.",
		},
		{
			title: 'CSS (Cascading Style Sheets)',
			info: "CSS is short for 'Cascading Style Sheets', which determines the visual appearance of a web page, including fonts, colours, and layouts.",
		},
		{
			title: 'Customer Lifetime Value (CLV)',
			info: 'The predicted total revenue a customer is expected to generate for a business throughout their entire relationship.',
		},
		{
			title: 'Customer Support',
			info: 'Services and resources provided to customers to assist them with inquiries, issues, or concerns related to a product or service.',
		},
		{
			title: 'Customs Duties',
			info: 'Customs duties are taxes or fees imposed on goods imported into a country. The amount is usually based on factors such as the value of the goods and the country of origin.',
		},
		{
			title: 'Customer Retention',
			info: 'The strategies and activities employed to keep existing customers engaged and loyal to your brand.',
		},
	],
	D: [
		{
			title: 'Dashboards',
			info: 'Visual displays of important metrics, data, and insights that provide a snapshot of business performance and facilitate data-driven decision-making.',
		},
		{
			title: 'Digital Marketing',
			info: 'Marketing strategies and tactics that utilise digital channels, such as search engines, social media, email, and websites, to reach and engage with a target audience.',
		},
		{
			title: 'Dropshipping',
			info: 'A fulfilment method where a retailer does not keep products in stock but instead transfers customer orders and shipment details to a third-party supplier who directly ships the products to the customer.',
		},
		{
			title: 'Dynamic Pricing',
			info: 'Dynamic pricing is a pricing strategy that involves adjusting product prices in real-time based on various factors, such as demand, competition, and customer segments.',
		},
		{
			title: 'Drop-off Rate',
			info: 'The percentage of users who leave a website or abandon a process, such as checkout, without completing the desired action.',
		},
		{
			title: 'Digital Wallet',
			info: 'A secure online application or service that allows users to store payment information and make transactions.',
		},
	],
	E: [
		{
			title: 'eCommerce',
			info: 'The buying and selling of goods and services over the internet, typically through an online store or marketplace.',
		},
		{
			title: 'Email Marketing',
			info: 'The practice of sending targeted emails to a group of individuals to promote products, deliver personalised offers, or nurture customer relationships (e.g., [LINK]).',
			link: {
				name: 'Klaviyo',
				url: 'https://www.klaviyo.com/',
			},
		},
		{
			title: 'ERP (Enterprise Resource Planning)',
			info: 'An integrated software system that combines various business functions, such as accounting, inventory management, and customer relationship management (CRM), into a unified platform.',
		},
		{
			title: 'Exit Intent Popup',
			info: 'An overlay or popup that appears when a user is about to leave a website, typically used to capture their attention, prevent them from leaving, and encourage them to take a specific action.',
		},
		{
			title: 'Expanding Collection',
			info: 'An expanding collection is a feature in Shopify that allows you to showcase a large number of products within a single collection, with the option to load more products as the user scrolls down.',
		},
	],
	F: [
		{
			title: 'Favicon',
			info: 'A small icon that represents a website or brand and appears in the browser tab or bookmark bar.',
		},
		{
			title: 'Fulfillment',
			info: 'The process of receiving, packaging, and delivering orders to customers.',
		},
		{
			title: 'Fulfillment Center',
			info: 'A dedicated facility or warehouse where products are stored, processed, and shipped to customers.',
		},
		{
			title: 'Fulfillment by Amazon (FBA)',
			info: 'A service provided by Amazon where sellers can store their products in Amazon fulfillment centers. Amazon then handles the packaging, shipping, and customer service on behalf of the seller.',
		},
		{
			title: 'Fulfillment Center',
			info: 'A warehouse or distribution center where products are stored, processed, and shipped to customers.',
		},
	],
	G: [
		{
			title: 'Gateway',
			info: 'A payment gateway is a service that authorizes credit card payments and processes transactions securely between the customer and the merchant.',
		},
		{
			title: 'Google Analytics',
			info: 'A web analytics tool by Google that provides detailed statistics about website traffic, user behavior, and conversion rates.',
		},
		{
			title: 'Google Shopping',
			info: 'Google Shopping is a platform where retailers can list and advertise their products, making them visible to users searching for related items on Google.',
		},
		{
			title: 'Gross Merchandise Value (GMV)',
			info: 'The total value of all products sold through an eCommerce platform within a specific time frame, excluding discounts and returns.',
		},
	],
	H: [
		{
			title: 'Heatmap',
			info: 'A visual representation of data where values are depicted using different colors, often used to show user engagement and interaction patterns on a website or webpage.',
		},
		{
			title: 'Hosting',
			info: 'The service of providing server space and resources for websites to be accessible on the internet.',
		},
	],
	I: [
		{
			title: 'Inventory Management',
			info: 'The process of overseeing and controlling the stock levels, storage, and availability of products in a retail or eCommerce business.',
		},
		{
			title: 'Influencer Marketing',
			info: 'A marketing strategy that involves collaborating with influential individuals or personalities, typically on social media platforms, to promote products or brands to their audience.',
		},
		{
			title: 'Invoice',
			info: 'A document sent to customers detailing the products or services purchased, including the quantity, price, and payment terms.',
		},
		{
			title: 'Inventory Turnover',
			info: 'A measure of how quickly a company sells its inventory within a specific period, indicating its efficiency in managing inventory levels.',
		},
	],
	J: [
		{
			title: 'JavaScript',
			info: 'A programming language commonly used to create interactive and dynamic elements on websites, such as forms, animations, and user interface components.',
		},
	],
	K: [
		{
			title: 'Keywords',
			info: 'Words or phrases that represent the main topics or themes of a webpage or content and are used by search engines to match relevant queries.',
		},
		{
			title: 'KPI (Key Performance Indicator)',
			info: 'A measurable value that demonstrates how effectively a business or individual is achieving key objectives or goals.',
		},
	],
	L: [
		{
			title: 'Landing Page',
			info: 'A standalone web page created specifically for a marketing or advertising campaign, with the goal of capturing visitor information or driving them towards a specific action.',
		},
		{
			title: 'Lead',
			info: 'A potential customer who has shown interest in a product or service and provided their contact information, typically through a form or subscription.',
		},
		{
			title: 'Lead Generation',
			info: 'The process of attracting and capturing potential customers, known as leads, and converting them into prospects or sales opportunities.',
		},
		{
			title: 'Lifetime Value (LTV)',
			info: 'Lifetime value (LTV) is the predicted revenue that a customer will generate throughout their entire relationship with a business.',
		},
		{
			title: 'Live Chat',
			info: 'A real-time messaging feature that allows customers to communicate with support representatives or sales agents directly on a website.',
		},
	],
	M: [
		{
			title: 'Marketplace',
			info: 'An online platform or website where multiple sellers can list and sell their products or services to a larger customer base.',
		},
		{
			title: 'Merchant',
			info: 'A person or business that sells products or services to customers.',
		},
		{
			title: 'Mobile Commerce (mCommerce)',
			info: 'The buying and selling of goods and services through mobile devices, such as smartphones and tablets.',
		},
		{
			title: 'Multi-Channel',
			info: 'The practice of selling products or services through multiple online and offline channels, such as a website, social media, marketplaces, and physical stores.',
		},
		{
			title: 'Multilingual',
			info: 'The ability of a website or platform to support multiple languages, allowing users from different regions or language backgrounds to access and navigate the content.',
		},
		{
			title: 'Mobile Commerce',
			info: 'The process of conducting commercial transactions through mobile devices, such as smartphones and tablets.',
		},
	],
	N: [
		{
			title: 'Navigation',
			info: 'The menu or system that allows users to navigate and browse different sections and pages of a website.',
		},
		{
			title: 'Niche',
			info: 'A specialized segment or market within a larger industry, focusing on specific products, services, or customer demographics.',
		},
		{
			title: 'Notifications',
			info: 'Messages or alerts that inform users about important updates, events, or actions related to their interactions with a website or application.',
		},
	],
	O: [
		{
			title: 'Omnichannel',
			info: 'An approach to sales and marketing that provides a seamless and integrated customer experience across multiple channels, both online and offline.',
		},
		{
			title: 'Order Management System (OMS)',
			info: 'A software or platform that helps businesses manage and track customer orders, inventory levels, and order fulfilment processes.',
		},
		{
			title: 'Out-of-Stock',
			info: 'When a product or item is not available for immediate purchase or is temporarily unavailable due to inventory depletion.',
		},
		{
			title: 'Order Tracking',
			info: "The process of monitoring and providing updates on the status and location of a customer's order from fulfillment to delivery.",
		},
	],
	P: [
		{
			title: 'Payment Gateway',
			info: 'A service that authorizes credit card payments and facilitates secure transactions between customers and merchants.',
		},
		{
			title: 'PCI DSS (Payment Card Industry Data Security Standard)',
			info: 'A set of security standards and requirements designed to ensure the safe handling of credit card information during online transactions.',
		},
		{
			title: 'Personalization',
			info: 'The process of tailoring content, recommendations, and experiences to individual users based on their preferences, behaviour, and demographic information.',
		},
		{
			title: 'Platform',
			info: 'A software or technology infrastructure that provides a foundation and tools for building and operating websites, online stores, or applications.',
		},
		{
			title: 'Plug-in',
			info: 'A software component or module that adds specific features, functionality, or integrations to an existing system or application.',
		},
		{
			title: 'POS (Point of Sale)',
			info: 'The physical location or system where a customer completes a purchase transaction, such as a cash register or a payment terminal.',
		},
		{
			title: 'Product Feed',
			info: "A file or data format that contains information about a retailer's products, including attributes, prices, and availability, which can be used for listing and advertising on various platforms and marketplaces.",
		},
		{
			title: 'Product Recommendation',
			info: "A personalized suggestion or recommendation of products or services based on a user's browsing or purchase history, preferences, or similarities to other customers.",
		},
		{
			title: 'PWA (Progressive Web App)',
			info: 'A web application that leverages modern web technologies to provide an app-like experience, such as offline access, push notifications, and home screen installation.',
		},
		{
			title: 'Personalization Engine',
			info: 'A software tool or algorithm that utilizes customer data and behavior to deliver tailored experiences, recommendations, and content.',
		},
		{
			title: 'Payment Processor',
			info: 'A service provider that handles the processing and authorization of online payment transactions.',
		},
		{
			title: 'Return Policy',
			info: 'The guidelines and procedures governing the return and refund process for products or services.',
		},
	],
	Q: [
		{
			title: 'QR Code',
			info: 'A two-dimensional barcode that can be scanned using a smartphone or QR code reader to quickly access information, websites, or promotions.',
		},
	],
	R: [
		{
			title: 'Referral Program',
			info: 'A marketing strategy that incentivizes existing customers to refer new customers to a business in exchange for rewards, discounts, or other benefits.',
		},
		{
			title: 'Return on Investment (ROI)',
			info: 'A measure of the profitability of an investment, calculated by dividing the net profit or benefit by the cost of the investment and expressed as a percentage.',
		},
		{
			title: 'Reviews',
			info: 'Written assessments, opinions, or ratings provided by customers about products, services, or businesses, often used to inform purchase decisions.',
		},
		{
			title: 'Rich Snippets',
			info: 'Structured data markup that allows search engines to display additional information, such as ratings, reviews, prices, and stock availability, directly in search results.',
		},
	],
	S: [
		{
			title: 'Search Engine Optimization (SEO)',
			info: "The process of improving a website's visibility and ranking in search engine results pages, with the goal of driving organic (non-paid) traffic.",
		},
		{
			title: 'Security',
			info: 'Measures and practices implemented to protect websites, applications, and user data from unauthorized access, data breaches, and other security threats.',
		},
		{
			title: 'Segmentation',
			info: 'The practice of dividing a target audience into smaller, more specific groups based on shared characteristics, preferences, or behaviours for more targeted marketing and personalization.',
		},
		{
			title: 'Shipping',
			info: 'The process of preparing and delivering products to customers, including packaging, carrier selection, and shipment tracking.',
		},
		{
			title: 'Shopify',
			info: 'A popular eCommerce platform that provides tools and services for creating and managing online stores, including website design, product management, and payment processing.',
		},
		{
			title: 'Shopify App Store',
			info: 'An online marketplace where merchants can find and install applications (apps) to add functionality and features to their Shopify stores.',
		},
		{
			title: 'Shopping Cart',
			info: 'A virtual cart or basket that allows users to add and manage products they intend to purchase.',
		},
		{
			title: 'Social Media Marketing',
			info: 'Promoting products, services, or brands on social media platforms, such as Facebook, Instagram, Twitter, or LinkedIn, to drive engagement, traffic, and sales.',
		},
		{
			title: 'SSL (Secure Sockets Layer)',
			info: 'A standard security protocol that establishes an encrypted link between a web server and a browser, ensuring that data transmitted between them remains secure and private.',
		},
		{
			title: 'Stock Keeping Unit (SKU)',
			info: 'A unique alphanumeric code or identifier assigned to each product to track and manage inventory.',
		},
		{
			title: 'Subscription',
			info: 'A recurring payment arrangement where customers agree to pay a specified amount at regular intervals to access products, services, or content.',
		},
		{
			title: 'Sales Funnel',
			info: 'A visual representation of the customer journey, illustrating the stages from initial awareness to making a purchase, typically divided into steps like awareness, consideration, and conversion.',
		},
		{
			title: 'Social Proof',
			info: 'The influence created by showcasing positive feedback, reviews, ratings, or endorsements from other customers to build trust and credibility.',
		},
		{
			title: 'Subscription Box',
			info: 'A recurring delivery service that offers customers a curated selection of products or samples on a subscription basis.',
		},
	],
	T: [
		{
			title: 'Target Audience',
			info: 'The specific group of people or customers that a business aims to reach and engage with through its marketing and advertising efforts.',
		},
		{
			title: 'Taxation',
			info: 'The process of imposing and collecting taxes on goods, services, or income, typically regulated and enforced by government authorities.',
		},
		{
			title: 'Theme',
			info: 'A collection of design elements, templates, and styles that determine the visual appearance and layout of a website or online store.',
		},
		{
			title: 'Tracking',
			info: 'The process of monitoring and recording user interactions, behaviors, or events on a website or application, often used for analytics, personalization, or marketing purposes.',
		},
		{
			title: 'Transactional Email',
			info: 'Automated emails triggered by specific user actions or events, such as order confirmation, shipping notifications, or password resets.',
		},
	],
	U: [
		{
			title: 'Upselling',
			info: 'A sales technique where customers are encouraged to purchase a higher-priced or upgraded version of a product or service to increase the average order value.',
		},
		{
			title: 'URL (Uniform Resource Locator)',
			info: 'The address or location that identifies a webpage or resource on the internet, typically starting with "http://" or "https://".',
		},
		{
			title: 'User Experience (UX)',
			info: 'The overall experience and satisfaction that users have when interacting with a website, application, or product, including factors like usability, accessibility, and design.',
		},
		{
			title: 'User-generated Reviews',
			info: 'Reviews and feedback provided by customers based on their experiences with products or services, often shared on review platforms or directly on eCommerce websites.',
		},
		{
			title: 'User-generated Content (UGC)',
			info: 'Content created and shared by users, such as reviews, testimonials, and social media posts, which can be leveraged for marketing and brand promotion.',
		},
		{
			title: 'User-generated Content (UGC)',
			info: 'Content created and shared by users, such as reviews, testimonials, and social media posts, which can be leveraged for marketing and brand promotion.',
		},
	],
	V: [
		{
			title: 'Value Proposition',
			info: 'The unique combination of benefits, solutions, or value that a product, service, or brand offers to customers, differentiating it from competitors and influencing purchase decisions.',
		},
		{
			title: 'Vendor',
			info: 'A person or company that supplies products or services to customers.',
		},
		{
			title: 'Virtual Reality (VR)',
			info: 'An immersive technology that creates a simulated, computer-generated environment or experience, often involving the use of headsets or other devices.',
		},
		{
			title: 'Visibility',
			info: 'The extent to which a website, brand, or product is easily discoverable and accessible to potential customers through search engines, advertising, or other channels.',
		},
		{
			title: 'Virtual Reality (VR) Shopping',
			info: 'An immersive technology that allows users to experience shopping in a simulated or virtual environment, providing a unique and interactive browsing and purchasing experience.',
		},
	],
	W: [
		{
			title: 'Web Design',
			info: 'The process of creating and arranging the visual layout, user interface, and overall look and feel of a website.',
		},
		{
			title: 'Web Hosting',
			info: 'A service that provides server space and resources for hosting websites, making them accessible on the internet.',
		},
		{
			title: 'Website',
			info: 'A collection of web pages, digital content, and multimedia that is accessible through a unique domain name and hosted on a web server.',
		},
		{
			title: 'Wholesale',
			info: 'The sale of goods or products in large quantities at lower prices, typically to retailers or other businesses for resale.',
		},
	],
	X: [
		{
			title: 'XML Sitemap',
			info: "An XML file that lists the URLs and metadata of a website's pages, helping search engines understand and index the site more effectively.",
		},
	],
	Z: [
		{
			title: 'Zero-Day',
			info: 'A zero-day refers to a vulnerability or software flaw that is discovered by hackers before the software developer becomes aware of it. This gives developers zero days to address and patch the issue, making it a high-risk security threat.',
		},
	],
};

export default glossaryIndex;
